import React from 'react';

import ullyImg from '../../assets/ully.svg';

import {
  Container,
  Title,
  SubTitle,
  Text,
  TextsWrapper,
  ButtonOK,
  TitleWrap,
  UllyContainer,
  UllyWrapper,
  UllyImage,
  UllyTextWrapper,
  UllyText,
  UllyLink,
} from './styles';

type ModalAnalistProps = {
  closeModal: () => void;
};

const ModalAnalist: React.FC<ModalAnalistProps> = ({ closeModal }) => {
  const handleClickOpenChat = (): void => {
    const chatbotButton = document?.querySelector(
      '#hi-custom-widget'
    ) as HTMLElement;
    if (chatbotButton) {
      chatbotButton?.click();
    }
  };

  return (
    <Container>
      <TitleWrap>
        <Title>Data sujeita a análise</Title>
      </TitleWrap>
      <TextsWrapper>
        <SubTitle>Solicitando data de atendimento</SubTitle>
        <Text>
          * A Data escolhida para o abastecimento da sua empresa/condomínio não
          é o dia de rota do nosso caminhão em sua região.
        </Text>
        <Text>
          * Após a conclusão do pedido nossa equipe irá analisar a possibilidade
          de atender na data solicitada.
        </Text>
        <Text>
          * Fique tranquilo, em breve você receberá a confirmação da data de
          entrega por e-mail!
        </Text>
      </TextsWrapper>
      <UllyContainer>
        <UllyWrapper>
          <UllyImage src={ullyImg} alt="Ully" />
        </UllyWrapper>
        <UllyTextWrapper>
          <UllyText>Se precisar de ajuda, fale com a</UllyText>
          <UllyLink onClick={() => handleClickOpenChat()}>Ully</UllyLink>
        </UllyTextWrapper>
      </UllyContainer>
      <ButtonOK onClick={() => closeModal()}>Entendi</ButtonOK>
    </Container>
  );
};

export default ModalAnalist;
